import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { RouteReuseStrategyService } from '../../services/route-reuse-strategy-service/route-reuse-strategy-service.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-live-streaming-page',
  templateUrl: './live-streaming-page.component.html',
  styleUrls: ['./live-streaming-page.component.scss']
})
export class LiveStreamingPageComponent implements OnInit, AfterViewInit, OnDestroy {

  private takeUntilSubject: Subject<any> = new Subject();
  private takeUntilRouteReuseStrategySubject: Subject<any> = new Subject();
  
  constructor(
    private routeReuseStrategyService: RouteReuseStrategyService
  ) {}

  ngOnInit(): void {
    this.routeReuseStrategyService.status = true;
    this.routeReuseStrategyService.routeReuseStrategySubject.pipe(
      takeUntil(this.takeUntilRouteReuseStrategySubject)
    ).subscribe(() => {
      this.takeUntilSubject.next(null);
      this.takeUntilSubject.complete();
      this.takeUntilSubject = new Subject();

      this.ngAfterViewInit();
    });
  }

  ngAfterViewInit(): void {
    window['orgMain'].showStreamingManage()
  }

  ngOnDestroy(): void {
    const $ = window['$'];
    $("#liveStream").hide();
    $("#liveStream").empty();

    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();

    this.takeUntilRouteReuseStrategySubject.next(null);
    this.takeUntilRouteReuseStrategySubject.complete();

    this.routeReuseStrategyService.status = false;

    /*
    $("body").removeClass("bg-color--white").removeClass("fixed-sn").addClass("fixed-sn");
    $("#header").css("float","none");
    $("#topNav").css("display","flex");
    $("#main").css("padding-top", "1.5em");
    $("#main-container").addClass("container-fluid");
    */
  }

}
